export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/selected-star-icon.png?8bf913ccef025d6fcaeb1f735c592616";